import { render, staticRenderFns } from "./GraphAudiometry.vue?vue&type=template&id=74d08580&"
import script from "./GraphAudiometry.vue?vue&type=script&lang=js&"
export * from "./GraphAudiometry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports